module.exports = __webpack_public_path__ + "img/technologyImg6.599e80e6.jpg";